/**
 * DetailCrumb
 * Componente invisible que registra el nombre del registro abierto en un
 * formulario/overlay para que aparezca en la barra de ruta global.
 *
 * Sustituye a las antiguas migas locales (`.dv-breadcrumb`) de la topbar de
 * los formularios: ahora la ruta se pinta en un único sitio.
 *
 * Uso:
 *   <DetailCrumb label={form.name} />
 */

import { useEffect, useRef } from 'react';
import { registerDetailCrumb, unregisterDetailCrumb } from '../contexts/BreadcrumbContext';

export default function DetailCrumb({ label }) {
  const idRef = useRef(null);
  if (idRef.current === null) idRef.current = Symbol('detail-crumb');

  useEffect(() => {
    const id = idRef.current;
    registerDetailCrumb(id, label || null);
    return () => unregisterDetailCrumb(id);
  }, [label]);

  return null;
}
